// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const reshiram: PokeData = {
  "id": 643,
  "name": "reshiram",
  "height": 32,
  "weight": 3300,
  "base_experience": 306,
  "types": [
    PokeType.DRAGON,
    PokeType.FIRE
  ],
  "api_moves": [
    "flamethrower",
    "dragon-rage",
    "fire-blast",
    "slash",
    "outrage",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "imprison",
    "hyper-voice",
    "extrasensory",
    "dragon-pulse",
    "fire-fang",
    "blue-flare",
    "fusion-flare",
    "noble-roar"
  ],
  "moves": [
    "flamethrower",
    "outrage",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "hyper-voice",
    "dragon-pulse",
    "fire-fang",
    "draco-meteor",
    "dragon-vortex",
    "ember",
    "dragon-rush",
    "flare-blitz"
  ],
  "evolution_chain": {
    "id": 330,
    "item": null,
    "species": [
      {
        "name": "reshiram",
        "order": 644,
        "types": [
          PokeType.DRAGON,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 104,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
